export default {
  unknown: 'Une erreur est survenue',
  message: {
    addMessage: 'Le message a bien été ajouté !',
    editMessage: 'Le message a bien été modifié !'
  },
  advice: {
    deleted: 'Le conseil a été supprimé avec succès !',
    kpiAdded: 'La KPI a bien été ajouté !',
    kpiEdited: 'La KPI a bien été modifié !',
    kpiDeleted: 'La KPI a été supprimé avec succès !'
  },
  user: {
    passwordEdited: 'Le mot de passe a été réinitialiser avec succès.',
    passwordSent: 'Un email de réinitialisation de mot de passe vous a été envoyé.',
    profileEdited: 'Vos informations ont été mis à jour avec succès.'
  },
  error: {
    fillForm: 'Vous devez remplir tous les champs.',
    smallPassword: 'Le mot de passe doit contenir au moins 8 caractères.',
    passwordDifferent: 'Les mots de passe ne sont pas identiques.',
    session: 'La session a expiré, veuillez vous reconnecter.'
  },
  customer: {
    created: 'Client crée!',
    edited: 'Client mis à jour!',
    deleted: 'Client supprimé!'
  },
  badge: {
    edited: 'Le badge a bien été mis à jour !',
    deleted: 'Le badge a été supprimer avec succès !',
    removedEvent: 'L\'évènement a bien été dissocié.',
    pasted: 'Le badge a bien été cree !'
  },
  campaign: {
    edited: 'La campagne a été modifier avec succès !',
    added: 'La campagne a été créer avec succès !',
    deleted: 'La campagne a été supprimer avec succès !',
    defineName: 'You must define a name to the campaign',
    startDate: 'Sélectionnez une date de début ou désélectionnez la limite.',
    endDate: 'Sélectionnez une date de fin ou désélectionnez la limite.'
  },
  bubble: {
    added: 'La bulle a bien été ajouté !',
    edited: 'Le bulle a bien été modifié !',
    refreshed: 'La bulle a été refresh avec succès !',
    deleted: 'La bulle a été supprimer avec succès !',
    eventRemoved: 'L\'événement a été déclenché pour les utilisateurs de la bulle.'
  },
  challenge: {
    updated: 'Le challenge a été mise à jour',
    published: 'Le challenge a été publié',
    deleted: 'Le challenge a été supprimé'
  },
  contest: {
    deleted: 'Le concours a bien été supprimé !',
    added: 'Le concour a bien été créé.',
    edited: 'Le concour a bien été mis à jour.'
  },
  event: {
    edited: 'L\'évènement a été mis à jour avec succès !',
    added: 'L\'évènement a été ajouté à jour avec succès !',
    deleted: 'L\'évènement a été supprimé avec succès !'
  },
  library: {
    added: 'La bibliothèque a bien été créer !',
    deleted: 'La bibliothèque a bien été supprimé !',
    mediaAdded: 'Le media a bien été ajouté !'
  },
  round: {
    deleted: 'Le round a bien été supprimé !',
    responsesSaved: 'Les réponses ont bien été enregistré',
    mancheEdited: 'La manche a bien été mis à jour.',
    mancheAdded: 'La manche a bien été créé.'
  },
  settings: {
    edited: 'Les modifications ont bien été prise en compte.',
    invalidIp: 'Adresse IP invalide.'
  },
  manager: {
    added: 'Le manager a été ajouté avec succès !',
    deleted: 'Le manager a été supprimé avec succès !'
  },
  translations: {
    edited: 'Les modifications ont bien été prise en compte'
  },
  site: {
    added: 'Le site a bien été ajouté !'
  },
  wave: {
    added: 'La vague a bien été ajouté !',
    duplicated: 'La vague a bien été dupliqué !',
    edited: 'La vague a bien été mise à jour !',
    deleted: 'La vague a bien été supprimé !'
  },
  banner: {
    added: 'La bannière a bien été ajouté !',
    duplicated: 'La bannière a bien été dupliqué !',
    edited: 'La bannière a bien été mise à jour !',
    deleted: 'La bannière a bien été supprimé !',
    cloned: 'La bannière a bien été cloné!',
    parameters: {
      url: 'Veuillez spécifier un URL!'
    }
  },
  survey: {
    added: 'Le sondage NPS a bien été ajouté !',
    duplicated: 'Le sondage NPS a bien été dupliqué !',
    edited: 'Le sondage NPS a bien été mise à jour !',
    deleted: 'Le sondage NPS a bien été supprimé !',
    cloned: 'Le sondage NPS a bien été cloné!',
  },
  wheel: {
    added: 'La Roue a bien été ajouté !',
    edited: 'La Roue a bien été mise à jour !',
    deleted: 'La Roue a bien été supprimé !'
  }
}



// WEBPACK FOOTER //
// ./src/translations/fr/notifications.js